<template>
  <v-dialog
    v-model="dialog"
    scrollable
    max-width="450"
    :fullscreen="this.$vuetify.breakpoint.xsOnly"
    persistent
  >
    <v-card :tile="this.$vuetify.breakpoint.xsOnly" class="white black--text">
      <v-toolbar light flat tile class="flex-grow-0">
        <v-toolbar-title class="font-weight-black title">
          {{ $t("addressDataNumber") }} {{ bet.id }}
          <span
            class="font-weight-black"
            v-html="$infoTable.statusBet(bet.status_bet)"
          ></span>
          <div class="caption">{{ bet.date | dateFormat }} {{ $gmt() }}</div>
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn icon v-on:click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider light></v-divider>
      <v-card-text class="pt-2 px-4 white black--text">
        <p class="text-center font-weight-bold" v-show="bet.status_bet != '1'">
          {{ $t("BETCONFERENCE") }}
          <br />
          {{ $t("NOVALIDFORAWARD") }}
        </p>

        <div class="py-0">
          <div
            v-for="(event, index) in bet.events"
            :key="event[0]"
            class="d-flex flex-column"
          >
            <v-divider light v-show="index" class="ml-8 pb-2"></v-divider>
            <div class="d-flex pb-2">
              <div class="pr-4 d-flex justify-center">
                <v-icon light>mdi-circle-medium</v-icon>
              </div>
              <div class="flex-grow-1 d-flex flex-column mr-2">
                <div class="overline">
                  {{ event.category_name }} - {{ event.tournaments_name }}
                </div>
                <div class="subtitle-2 font-weight-bold">
                  {{ nameOdds(event.id_outcome) }}
                </div>
                <div class="caption">
                  {{ $t("market") }}: {{ nameMarkets(event.id_market) }}
                </div>
                <div class="subtitle-2">
                  {{ event.description }}
                </div>
                <div class="caption">{{ event.scheduled | dateFormat }}</div>
              </div>
              <div class="d-flex flex-column justify-center align-end">
                <div class="font-weight-black">{{ event.factor_event }}</div>
                <div
                  class="font-weight-black"
                  v-html="conference(event.result_event, event.status_event)"
                ></div>
                <v-chip
                  v-if="event.live_event === '1'"
                  class="font-weight-black"
                  color="info"
                  small
                >
                  {{ $t("live") }}
                </v-chip>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>

      <v-divider light></v-divider>

      <v-card-actions>
        <div class="py-2 px-2 d-flex flex-grow-1 flex-column body-2">
          <div
            v-if="!bet.action"
            class="d-flex justify-space-between align-center"
          >
            <div>{{ $t("allOdds") }}</div>
            <div class="font-weight-black">{{ bet.factor_bet }}</div>
          </div>
          <div
            v-if="!bet.action"
            class="d-flex justify-space-between align-center"
          >
            <div>{{ $t("value") }}</div>
            <div class="font-weight-black">{{ bet.amount }}</div>
          </div>

          <div
            v-if="!bet.action"
            class="d-flex justify-space-between align-center"
          >
            <div>{{ $t("possibleReturn") }}</div>
            <div class="font-weight-black">{{ bet.prize }}</div>
          </div>

          <div
            v-if="!bet.action && agentPercentage && agentPercentage > 0"
            class="d-flex justify-space-between align-center"
          >
            <div>{{ $t("clientGains") }}</div>
            <div class="font-weight-black">
              {{ (bet.prize - bet.prize * agentPercentage).toFixed(2) }}
            </div>
          </div>

          <div
            v-if="bet.action"
            class="d-flex justify-space-between align-center"
          >
            <div>{{ $t("action") }}</div>
            <div class="font-weight-black">{{ bet.action }}</div>
          </div>
          <div
            v-if="bet.action"
            class="d-flex justify-space-between align-center"
          >
            <div>{{ $t("reverseAmount") }}</div>
            <div class="font-weight-black">{{ bet.factor * bet.amount }}</div>
          </div>
          <div class="d-flex justify-space-between align-center">
            <div>{{ $t("conference") }}</div>
            <div
              class="font-weight-black"
              v-html="conference(bet.result_bet, bet.status_bet, bet.reason)"
            ></div>
          </div>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style>
.bet-aut {
  word-wrap: break-word !important;
}
</style>

<script>
// import QrcodeVue from "qrcode.vue";
// import Vue from "vue";
export default {
  name: "dialog-consult-bet",
  props: ["data"],
  components: {
    // QrcodeVue,
  },
  data: () => {
    return {
      bet: "",
      dialog: false,
      valueQrcode: "",
      sizeQrcode: 100,
      agent: "",
    };
  },

  watch: {
    data: {
      handler: function(val) {
        this.agent = val.agent;
        this.bet = val.dados.apostas[0];
        this.dialog = true;
      },
      deep: true,
    },
  },

  computed: {
    agentPercentage() {
      if (
        this.$store.state.operators &&
        this.$store.state.operators.retail == 1 &&
        this.$isAgent()
      ) {
        const agent = this.agent;

        if (agent) {
          const { percentage_prize, events_prize } = agent;

          if (percentage_prize && events_prize) {
            if (percentage_prize > 0) {
              const bet_data = this.bet;

              if (bet_data && bet_data.events.length >= events_prize) {
                return percentage_prize / 100;
              } else {
                return 0;
              }
            } else {
              return 0;
            }
          }
        }
      }

      return 0;
    },
  },

  methods: {
    nameMarkets(id_market) {
      const markets = this.$store.getters.getMarkets;
      for (let m of markets) {
        if (m.id_market == id_market) {
          return m.name_market;
        }
      }
    },

    nameOdds(id_outcome) {
      const odds = this.$store.getters.getResults;
      for (let o of odds) {
        if (o.id_outcome == id_outcome) {
          return o.name_outcome;
        }
      }
    },

    msgReasion: function(r) {
      const msg_reasion = {
        0: "OTHER",
        1: "NO_GOALSCORER",
        2: "CORRECT_SCORE_MISSING",
        3: "RESULT_UNVERIFIABLE",
        4: "FORMAT_CHANGE",
        5: "CANCELLED_EVENT",
        6: "MISSING_GOALSCORER",
        7: "MATCH_ENDED_IN_WALKOVER",
        8: "DEAD_HEAT",
        9: "RETIRED_OR_DEFAULTED",
        10: "EVENT_ABANDONED",
        11: "EVENT_POSTPONED",
        12: "INCORRECT_ODDS",
        13: "INCORRECT_STATISTICS",
        14: "NO_RESULT_ASSIGNABLE",
        15: "CLIENT_SIDE_SETTLEMENT_NEEDED",
        16: "STARTING_PITCHER_CHANGED",
      };

      return msg_reasion[r];
    },

    conference: function(result_bet, status_bet, reason) {
      if (status_bet == 0) {
        return '<span class="my-1 v-chip theme--light v-size--small purple darken-3 white--text"><span class="v-chip__content text">Cancelado</span></span>';
      } else {
        if (result_bet == 1) {
          return '<span class="my-1 v-chip theme--light v-size--small green darken-3 white--text"><span class="v-chip__content">Acertou</span></span>';
        } else if (result_bet == 0 && result_bet != "") {
          if (reason) {
            return `<span class="orange--text">Reembolso</span><strong class="orange--text"> (${this.msgReasion(
              reason
            )})</strong>`;
          } else {
            return '<span class="my-1 v-chip theme--light v-size--small red darken-3 white--text"><span class="v-chip__content">Errou</span></span>';
          }
        } else {
          return '<span class="my-1 v-chip theme--light v-size--small grey darken-3 white--text"><span class="v-chip__content">Pendente</span></span>';
        }
      }
    },
  },
  filters: {
    dateFormat: function(datedb) {
      if (datedb == undefined) return;
      let date = new Date(datedb.replace(" ", "T")).toLocaleString();
      return date;
    },
  },
};
</script>
